import apiClient from './api'

export default {
    async get (id) {
        return await apiClient.get(`/cms/subscriptions/${id}`)
    },
    async getAll (params = {}) {
        params.paginate = false
        return await apiClient.get('/cms/subscriptions', { params })
    },
    async paginate (params) {
        params.paginate = true
        params.perPage = params.itemsPerPage
        const result = await apiClient.get('/cms/subscriptions', { params })
        result.data.total = Number(result.data.total)
        return result
    },
    async cancel (id) {
        return await apiClient.post(`/cms/subscriptions/${id}/cancel`)
    },
}